module.exports = __webpack_public_path__ + "img/crustaces.baf61deb.svg";